module.exports = __webpack_public_path__ + "img/002.b80b9c58.jpg";